import styled, { css } from 'styled-components';
import { Divider } from 'src/components/divider';
import { KIOSK_PRO_MEDIA } from '../kiosk-pro-shared/kiosk-pro-shared.styles';

const longTitleClearance = css`
  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    padding-top: var(--dcm-kiosk-login-options-long-title-padding-top, 144px);
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    padding-top: var(--dcm-kiosk-login-options-long-title-padding-top-sm, 128px);
  }
`;

export const LoginOptionsContainer = styled.div<{ $hasLongTitle?: boolean }>`
  text-align: center;
  margin: 0 auto;
  padding: 160px 72px 72px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 72px;
  min-height: 100svh;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    padding: 56px;
    gap: 56px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    padding: 48px;
    gap: 48px;
  }

  ${({ $hasLongTitle }) => $hasLongTitle && longTitleClearance}
`;

export const KioskLoginOptionsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 148px 530px;
  gap: 12px;
  max-width: 1920px;
  margin: 0 auto;
  width: 100%;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    grid-template-columns: 1fr 100px 430px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    grid-template-columns: minmax(0, 1fr) 80px minmax(0, 348px);
    gap: 10px;
    max-width: 100%;
    min-width: 0;
  }

  @media (orientation: portrait) {
    grid-template-columns: 1fr;
    gap: 56px;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    gap: 28px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    gap: 24px;
  }
`;

// $centered: vertically centers the content in the card (it's stretched to the guest card's height),
// used for the short "sign-in isn't set up" message (ECOMM-13062).
export const LoginContainer = styled.div<{ $centered?: boolean }>`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 56px;
  border-radius: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${({ $centered }) => ($centered ? 'center' : 'flex-start')};
  gap: 72px;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    padding: 40px;
    gap: 56px;
  }

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    padding: 40px;
    gap: 56px;
    border-radius: 28px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait} {
    padding: 36px;
    border-radius: 24px;
    height: auto;
    gap: 48px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    padding: 36px;
    gap: 48px;
  }
`;

export const LoginOptionsTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    gap: 14px;
  }
`;

export const QRCodeLoginContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: start;
  width: 100%;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    gap: 16px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    gap: 10px;
  }
`;

export const VerticalDivider = styled.div`
  width: 4px;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.colors.grey[90]};
  border-radius: 2px;
  height: 100%;
`;

export const SubText = styled.p`
  font-size: 24px;
  color: ${({ theme }) => theme.colors.grey[30]};

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 20px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    font-size: 16px;
  }
`;

export const LoginDivider = styled(Divider)`
  font-size: 36px;
  color: ${({ theme }) => theme.colors.grey[30]};
  margin: 0;

  @media ${KIOSK_PRO_MEDIA.landscapeMaxWidth}, ${KIOSK_PRO_MEDIA.portraitMaxWidth} {
    font-size: 28px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    font-size: 24px;
  }
`;
